export const SHOW_RIGHT_POPUP_PROPS = 'SHOW_RIGHT_POPUP_PROPS';
export const HIDE_RIGHT_POPUP_BOX = 'HIDE_RIGHT_POPUP_BOX';